export default {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    totalAmount: '<'
  },
  controller: 'paymentDetailsController',
  template: require('../views/payment.details.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/components/payment.details.component.js